import React from 'react';

import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';

class SODDDifferenceModal extends React.Component {
  constructor(props) {
    super(props);
    this.getModalBody = this.getModalBody.bind(this);
  }

  getModalBody() {
    return (
      <div>
        <p
          dangerouslySetInnerHTML={{ __html: this.props.content.DDDefinition }}
        />
        <p
          dangerouslySetInnerHTML={{ __html: this.props.content.SODefinition }}
        />
        <p>{this.props.content.DDSOInfo}</p>
      </div>
    );
  }

  getModalFooter() {
    return (
      <button
        className="c-btn c-btn--default c-modal__button"
        onClick={this.props.closeModal}
      >
        {' '}
        {this.props.content.DDSOModalClose}
      </button>
    );
  }

  render() {
    return (
      <PatternLibModalComponent
        show
        onHide={this.props.closeModal}
        bsSize={'medium'}
        modalHeading={this.props.content.DDSOModalTextHeader}
        modalBody={this.getModalBody()}
        modalFooter={this.getModalFooter()}
        customClass={'c-modal'}
      />
    );
  }
}

export default SODDDifferenceModal;
